// Domain types for the Admin Rate Tables MSPA.

// A row in the rate tables list table.
export interface RateTable {
  id: string;
  name: string;
  currencyId: string | null;
  currencyName: string;
  accountingCode: string;
  default: boolean;
}

// Controlled values for the rate table create/edit form.
export interface RateTableFormValues {
  name: string;
  currencyId: string;
  accountingCode: string;
  default: boolean;
}

export const emptyRateTableForm: RateTableFormValues = {
  name: "",
  currencyId: "",
  accountingCode: "",
  default: false,
};

// A row in the resource rates tab table.
export interface ResourceRate {
  id: string;
  resourceId: string;
  resourceName: string;
  externalName: string;
  description: string;
  lobId: string | null;
  lobName: string;
  hourlyRate: number | null;
  hourlyCost: number | null;
  expenseRate: number | null;
  code: string;
}

// Controlled values for the resource rate create/edit form.
export interface ResourceRateFormValues {
  resourceId: string;
  externalName: string;
  description: string;
  lobId: string;
  hourlyRate: number | null;
  hourlyCost: number | null;
  expenseRate: number | null;
  code: string;
}

export const emptyResourceRateForm: ResourceRateFormValues = {
  resourceId: "",
  externalName: "",
  description: "",
  lobId: "",
  hourlyRate: null,
  hourlyCost: null,
  expenseRate: null,
  code: "",
};
